import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { AppContext } from "../../AppContext";
import {

    Typography,

    Box,


} from "@mui/material";
import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EmailIcon from "@mui/icons-material/Email";

export default function AmbassadorCard({ actualDeal }) {
    console.log(actualDeal);
    const app = useContext(AppContext);
    const handleSendAmbassadorInviteMail = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/d631f9e1ba44475b8dd7ce760ad3538e/" + actualDeal.uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        app.refSnack.current.handleChangeState({ o: true, m: "Le mail a été renvoyé", s: "success" });
                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };
    return (
        <CardTemplate
            title="Ambassadeur"
            buttons={(actualDeal.ambassador_defined && actualDeal.ambassador_ok === null) ?
                <ButtonWithTooltipAndBadge
                    tooltip="Renvoyer le mail d'invitation"
                    icon={<EmailIcon />}
                    onclick_cb={handleSendAmbassadorInviteMail}
                    badge={true} />
                : null
            }

            content={
                <Fragment>
                    <Box
                        display="flex"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                    >
                        {actualDeal.ambassador_defined && actualDeal.ambassador_ok === null && (
                            <Box >
                                <Typography variant="body1">L'ambassadeur n'a pas encore accepté l'invitation</Typography>
                            </Box>
                        )}
                        {!actualDeal.ambassador_defined && actualDeal.ambassador_ok === false && (
                            <Box >
                                <Typography variant="body1">L'ambassadeur a refusé l'invitation</Typography>
                    

                                <ButtonWithTooltipAndBadge
                                    tooltip="Inviter un ambassadeur"
                                    icon={<PersonAddAltIcon />}
                                    onclick_cb={() => app.refPopUp.current.handleChangeState(
                                        {
                                            opened: true,
                                            type: "012",
                                            params: {
                                                ip: actualDeal.idp,
                                                deal_uid: actualDeal.deal_uid,
                                                sellers: actualDeal.sellers.filter((s) => {
                                                    return s.uid !== actualDeal.uid;
                                                }),
                                            }
                                        }
                                    )}
                                    badge={true} />
                            </Box>
                        )}
                        {!actualDeal.ambassador_defined && actualDeal.ambassador_ok === null && (
                            <Box >
                                <Typography variant="body1">L'ambassadeur n'est pas encore défini</Typography>

                                <ButtonWithTooltipAndBadge
                                    tooltip="Inviter un ambassadeur"
                                    icon={<PersonAddAltIcon />}
                                    onclick_cb={() => app.refPopUp.current.handleChangeState(
                                        {
                                            opened: true,
                                            type: "012",
                                            params: {
                                                ip: actualDeal.idp,
                                                deal_uid: actualDeal.deal_uid,
                                                sellers: actualDeal.sellers.filter((s) => {
                                                    return s.uid !== actualDeal.uid;
                                                }),
                                            }
                                        })}
                                    badge={true} />
                            </Box>
                        )}
                        {actualDeal.ambassador_defined && actualDeal.ambassador_ok === true && (
                            <Box >
                                <Typography variant="body1">{actualDeal.ambassador_details}</Typography>
                            </Box>
                        )}
                    </Box>
                </Fragment>
            }
        />)

}